export const VISIT_INTENTION_OPTIONS = [
  { value: 'indefinido', label: 'Indefinido' },
  { value: 'presencial', label: 'Presencial' },
  { value: 'virtual', label: 'Virtual' },
  { value: 'retorno', label: 'Retorno' },
];

export const ENTRY_ACCESS_OPTIONS = [
  {
    value: 'A_COMBINAR',
    label: 'A combinar',
    helper: 'Combine com o responsável antes de confirmar a visita.',
  },
  {
    value: 'PASSWORD',
    label: 'Chave por senha',
    helper: 'Informamos a senha para o parceiro que vai visitar o imóvel.',
  },
  {
    value: 'FRONT_DOOR',
    label: 'Chaves na portaria',
    helper:
      'As chaves ficam na portaria, junto com a autorização de entrada dos parceiros.',
  },
  {
    value: 'KEYS_WITH_AGENT',
    label: 'Chaves com o Corretor',
    helper:
      'Um corretor parceiro fica responsável pelas chaves e todas as visitas.',
  },
  {
    value: 'KEYS_WITH_OWNER',
    label: 'Chaves com proprietário',
    helper:
      'O proprietário precisa abrir a porta e garantir a autorização de entrada dos parceiros.',
  },
  {
    value: 'KEYS_WITH_TENANT_LIVING',
    label: 'Chaves com o atual inquilino',
    helper:
      'O atual inquilino ainda mora no imóvel e é responsável por abrir o imóvel em todas as visitas.',
  },
  {
    value: 'KEYS_WITH_EXTERNAL_RESPONSIBLE',
    label: 'Chaves com outro responsável',
    helper:
      'Um vizinho, familiar ou amigo fica com as chaves e é responsável por abrir o imóvel em todas as visitas.',
  },
  {
    value: 'KEYS_WITH_PARTNER',
    label: 'Chaves na imobiliária parceira',
    helper:
      'As chaves ficam disponíveis em imobiliárias parceiras e o proprietário precisa autorizar a visita.',
  },
];

export const ENTRY_AUTHORIZATION_OPTIONS = ENTRY_ACCESS_OPTIONS;

export const ENTRANCE_BLOCKER_OPTIONS = [
  {
    value: 'wrong_info',
    label: 'Informação de entrada incorreta',
  },
  {
    value: 'key_problem',
    label: 'Problema com chave',
  },
  {
    value: 'no_permission',
    label: 'Sem permissão de entrada',
  },
  {
    value: 'out_of_hours',
    label: 'Fora do horário permitido',
  },
  {
    value: 'tenant_denied',
    label: 'Inquilino não autorizou',
  },
  {
    value: 'no_answer',
    label: 'Ninguém atendeu no horário combinado',
  },
  {
    value: 'address_not_found',
    label: 'Endereço não encontrado',
  },
  {
    value: 'construction_or_renovation',
    label: 'Obra ou reforma impediu a entrada',
  },
  {
    value: 'safety_or_pet',
    label: 'Risco de segurança ou animal no imóvel',
  },
  {
    value: 'condominium_denied',
    label: 'Condomínio negou o acesso',
  },
  {
    value: 'other',
    label: 'Outro motivo',
  },
];

export const CORRECT_ENTRY_INFO_OPTIONS = [
  {
    value: 'all_correct',
    label: 'Tudo correto',
  },
  {
    value: 'unknown',
    label: 'Não sei informar',
  },
  {
    value: 'wrong_address',
    label: 'Endereço incorreto',
  },
  {
    value: 'wrong_complement',
    label: 'Complemento ou unidade incorreta',
  },
  {
    value: 'doorman_instruction',
    label: 'Instrução de portaria desatualizada',
  },
  {
    value: 'wrong_responsible_contact',
    label: 'Contato do responsável incorreto',
  },
  {
    value: 'password_or_biometry',
    label: 'Senha ou biometria incorreta',
  },
  {
    value: 'other',
    label: 'Outro dado de entrada',
  },
];

export const KEY_PROBLEM_OPTIONS = [
  {
    value: 'key_does_not_open',
    label: 'A chave não abre',
  },
  {
    value: 'lock_changed',
    label: 'Chave/fechadura quebrada',
  },
  {
    value: 'key_not_available',
    label: 'A chave não estava na LockBox',
  },
  {
    value: 'password_or_biometry_failed',
    label: 'Senha de acesso errada',
  },
  {
    value: 'damaged_key',
    label: 'A chave estava danificada',
  },
];

export const ENTRY_DOORMAN_OPTIONS = [
  { value: 'TWENTY_FOUR_HOURS', label: '24 horas' },
  { value: 'DAYTIME', label: 'Diurna' },
  { value: 'NIGHTTIME', label: 'Noturna' },
  { value: 'NO_FRONT_DOOR', label: 'Sem portaria' },
];

export const ENTRY_OCCUPANCY_OPTIONS = [
  { value: 'TENANT_LIVING', label: 'Inquilino mora' },
  { value: 'OWNER_LIVING', label: 'Proprietário mora' },
  { value: 'VACANT', label: 'Está vago' },
];

export const ENTRY_KEY_TYPE_OPTIONS = [
  { value: 'COMMON', label: 'Chave' },
  { value: 'PASSWORD', label: 'Senha' },
  { value: 'BIOMETRY', label: 'Biometria' },
];

export const ENTRY_CONDITIONS_LABELS = {
  frontdoor: 'Qual o horário da portaria?',
  occupancy: 'Alguém mora no imóvel?',
  vacantAt: 'Quando estará vago?',
  keyType: 'Qual o tipo de chave?',
  password: 'Senha',
  responsibleName: 'Nome do responsável',
  responsiblePhone: 'Telefone de contato',
  responsiblePhoneHelper: 'Prefira número de celular com WhatsApp',
  responsibleAddress: 'Endereço do responsável',
  responsibleAddressHelper:
    'Caso as chaves estejam em um local diferente do imóvel.',
  instructions: 'Instruções de acesso',
};

export const VISIT_HIGH_DEMAND_LABEL = 'Alta Procura';

export const VISITS_EMPTY_STATE_TITLE =
  'Você ainda não possui visitas agendadas para esse dia.';

export const VISITS_EMPTY_STATE_DESCRIPTION = '';

export const VISITS_ERROR_STATE_TITLE = 'Ocorreu algo inesperado';

export const VISITS_ERROR_STATE_DESCRIPTION =
  'Atualize a página para carregar as informações novamente.';

export const VISIT_TIME_EXPIRED_LABEL = 'Horário expirou';

export const VISIT_CANCEL_EXPIRED_MESSAGE =
  'Essa visita não pode ser cancelada porque o horário expirou.';

export const VISIT_CONFIRM_EXPIRED_MESSAGE =
  'Essa visita não pode ser confirmada porque o horário expirou.';

export const VISIT_CANCELLATION_NOTICE =
  'O cancelamento frustra a pessoa interessada e pode ser mais difícil fechar negócio.';

export const VISIT_CANCEL_CONFIRM_TITLE = 'Quer mesmo cancelar esta visita?';

export const VISIT_CANCEL_CONFIRM_LABEL = 'Sim, cancelar a visita';

export const VISIT_CANCEL_SUSPEND_CONFIRM_LABEL =
  'Cancelar visita e suspender anúncio';

export const VISIT_CANCEL_ERROR_MESSAGE = 'Ocorreu um erro. Tente novamente.';

export const VISIT_CANCEL_SUMMARY_TITLE = 'Resumo da visita';

export const VISIT_CANCEL_DETAILS_TITLE = 'Detalhes da visita';

export const VISIT_CANCEL_REASON_TITLE =
  'Por qual motivo essa visita precisa ser cancelada?';

export const VISIT_CANCEL_SUCCESS_TITLE = 'A visita foi cancelada';

export const VISIT_CANCEL_SUCCESS_MESSAGE =
  'Cancelamos esta visita e já informamos a pessoa interessada e o corretor.';

export const VISIT_CANCEL_RESCHEDULE_TEXT =
  'Que tal reagendar? Em vez de cancelar, converse com o corretor para combinar outro horário';

export const VISIT_CANCEL_RESCHEDULE_LINK = 'Reagendar visita';

export const VISIT_CANCEL_SUSPEND_TITLE =
  'Para evitar outros cancelamentos, sugerimos suspender o anúncio temporariamente';

export const VISIT_CANCEL_SUSPEND_LABEL = 'Suspender anúncio por 7 dias';

export const VISIT_CANCEL_SUSPEND_HELPER =
  'Propostas em andamento continuam ativas';

export const VISIT_CANCEL_SUSPEND_BODY =
  'Esta visita vai ser cancelada e o imóvel não vai receber novas visitas até a data informada.';

export const VISIT_CANCEL_SUSPEND_FLOW_TITLE =
  'Suspender anúncio temporariamente';

export const VISIT_CANCEL_SUSPEND_FLOW_BODY =
  'Esta visita vai ser cancelada e o imóvel não vai receber novas visitas até a data informada.';

export const VISIT_CANCEL_SUSPEND_SUCCESS_TITLE =
  'Seu anúncio foi suspenso temporariamente';

export const VISIT_CANCEL_SUSPEND_SUCCESS_MESSAGE =
  'Seu imóvel não vai receber novas visitas durante a suspensão do anúncio. Propostas ativas continuam em andamento.';

export const VISIT_CANCEL_SUSPEND_PERIOD_LABEL =
  'Selecione o período da suspensão';

export const VISIT_CANCEL_SUSPEND_LAST_DAY_LABEL = 'Suspender anúncio até';

export const VISIT_CANCEL_INVALID_DATE_MESSAGE = 'Data inválida';

export const VISIT_CANCEL_INVALID_FIRST_DAY_MESSAGE =
  'O primeiro dia não pode ser depois do último dia';

export const VISIT_CANCEL_INVALID_LAST_DAY_MESSAGE =
  'O último dia não pode ser antes do primeiro dia';

export const republishAlertMessage = date =>
  `Vamos voltar a anunciar seu imóvel no dia ${date}.`;

export const VISIT_CANCEL_RESPONSIBLE_OPTIONS = [
  { value: 'agent', label: 'o corretor' },
  { value: 'demand', label: 'o cliente' },
  { value: 'supply', label: 'o proprietário' },
  { value: 'yourself', label: 'você' },
  { value: 'tenant_living', label: 'o atual inquilino' },
];

const DEMAND_REASON_OPTIONS = [
  {
    value: 'another_visit_scheduled',
    label: 'Tem uma visita agendada para este imóvel em outro horário',
  },
  {
    value: 'visited_at_different_time',
    label: 'Já visitou este imóvel em outro horário',
  },
  {
    value: 'client_stopped_responding',
    label: 'O cliente não respondeu mais, não confio que a visita vá acontecer',
  },
  {
    value: 'client_agent_problem',
    label:
      'Teve problemas com o corretor ou não quer mais fazer a visita com ele',
  },
];

const SUPPLY_REASON_OPTIONS = [
  {
    value: 'owner_cannot_this_time',
    label:
      'Não pode neste horário, mas ainda tem interesse em receber visitas no imóvel',
  },
  {
    value: 'property_temporarily_unavailable',
    label: 'O imóvel está temporariamente indisponível para visitas',
  },
  {
    value: 'property_unavailable_or_unlisted',
    label:
      'O imóvel foi alugado/vendido ou o proprietário desistiu de anunciar',
  },
  {
    value: 'advanced_offer_selected',
    label: 'O imóvel já possui uma proposta avançada escolhida',
  },
  {
    value: 'owner_stopped_responding',
    label: 'O proprietário não respondeu, não confio que a visita vá acontecer',
  },
  {
    value: 'owner_agent_problem',
    label:
      'Teve problemas com o corretor ou não quer mais fazer a visita com ele',
  },
];

const AGENT_REASON_OPTIONS = [
  {
    value: 'agent_not_interested',
    label: 'O corretor não tem interesse na visita',
  },
  {
    value: 'agent_cannot_this_time',
    label: 'O corretor não pode neste horário',
  },
  {
    value: 'agent_does_not_want_location',
    label: 'O corretor não quer comparecer à visita neste local',
  },
  {
    value: 'agent_problem',
    label: 'Houveram problemas com o corretor de visitas atual',
  },
];

const TENANT_LIVING_REASON_OPTIONS = [
  {
    value: 'tenant_cannot_this_time',
    label: 'Não pode neste horário, mas pode receber a visita em outro horário',
  },
  {
    value: 'tenant_stopped_responding',
    label: 'O inquilino não respondeu, não confio que a visita vá acontecer',
  },
  {
    value: 'tenant_does_not_want_imudei',
    label: 'Não quer receber visitas da Imudei',
  },
];

const YOURSELF_REASON_OPTIONS = [
  {
    value: 'want_another_agent',
    label: 'Quero outro corretor',
  },
  {
    value: 'reschedule_instead',
    label: 'Você pode reagendar essa visita ao invés de cancelar.',
  },
];

export const VISIT_CANCEL_REASON_OPTIONS_BY_RESPONSIBLE = {
  agent: AGENT_REASON_OPTIONS,
  demand: DEMAND_REASON_OPTIONS,
  supply: SUPPLY_REASON_OPTIONS,
  yourself: YOURSELF_REASON_OPTIONS,
  tenant_living: TENANT_LIVING_REASON_OPTIONS,
};

export const getCancelReasonOptions = (
  responsible,
  { canSuspendListing = false } = {}
) => {
  const options = VISIT_CANCEL_REASON_OPTIONS_BY_RESPONSIBLE[responsible] || [];
  if (canSuspendListing) return options;

  return options.filter(
    option => option.value !== 'property_temporarily_unavailable'
  );
};

export const getCancelMessage = (
  reasonValue,
  { canSuspendListing = false } = {}
) => {
  if (canSuspendListing && reasonValue === 'property_unavailable_or_unlisted') {
    return VISIT_CANCEL_SUSPEND_BODY;
  }

  return reasonValue === 'property_temporarily_unavailable'
    ? VISIT_CANCEL_SUSPEND_BODY
    : '';
};

const optionLabel = (options, value, fallback = '—') =>
  options.find(item => item.value === value)?.label || fallback;

const legacyEntryAccessMap = {
  'A combinar': 'A_COMBINAR',
  'Portaria ou senha': 'FRONT_DOOR',
  'Chaves com corretor': 'KEYS_WITH_AGENT',
  'Chaves com o Corretor': 'KEYS_WITH_AGENT',
  'Chaves com o proprietário': 'KEYS_WITH_OWNER',
  'Chaves com proprietário': 'KEYS_WITH_OWNER',
  'Proprietário no local': 'KEYS_WITH_OWNER',
  'Chaves com o atual inquilino': 'KEYS_WITH_TENANT_LIVING',
  'Atual inquilino no local': 'KEYS_WITH_TENANT_LIVING',
  'Chaves com outro responsável': 'KEYS_WITH_EXTERNAL_RESPONSIBLE',
  'Chaves na imobiliária parceira': 'KEYS_WITH_PARTNER',
};

export const normalizeEntryAccessKey = value =>
  legacyEntryAccessMap[value] || value || 'A_COMBINAR';

const legacyDoormanMap = {
  '24hrs': 'TWENTY_FOUR_HOURS',
  '24 horas': 'TWENTY_FOUR_HOURS',
};

export const entryAccessLabel = value =>
  optionLabel(
    ENTRY_ACCESS_OPTIONS,
    normalizeEntryAccessKey(value),
    value || 'A combinar'
  );

export const entryAccessHelper = value =>
  ENTRY_ACCESS_OPTIONS.find(
    item => item.value === normalizeEntryAccessKey(value)
  )?.helper || '';

export const doormanLabel = value =>
  optionLabel(
    ENTRY_DOORMAN_OPTIONS,
    legacyDoormanMap[value] || value,
    value || '—'
  );

export const occupancyLabel = value =>
  optionLabel(ENTRY_OCCUPANCY_OPTIONS, value, value || '—');

export const keyTypeLabel = value =>
  optionLabel(ENTRY_KEY_TYPE_OPTIONS, value, value || '—');

export const visitIntentionLabel = value =>
  optionLabel(VISIT_INTENTION_OPTIONS, value, 'Sem definição');

export const cancelResponsibleLabel = value =>
  optionLabel(VISIT_CANCEL_RESPONSIBLE_OPTIONS, value, '—');

export const cancelReasonLabel = (responsible, reason) =>
  optionLabel(
    VISIT_CANCEL_REASON_OPTIONS_BY_RESPONSIBLE[responsible] || [],
    reason,
    reason || '—'
  );
